import ILogger from './ILogger'
import isObject from 'lodash/isObject'
import { isObjectValuesAreString } from './helpers'
import ignoreThirdLevelOfNestingObject from './ignoreThirdLevelOfNestingObject'

export default class SentryLogger extends ILogger {
  /**
   * @param {object} sentry
   * @param {function} getContext
   */
  constructor (sentry, getContext) {
    super()

    this._sentry = sentry
    this._getContext = getContext
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   * @throws {TypeError}
   * @private
   */
  _validate (error, extra, tagMap) {
    if (!(error instanceof Error)) {
      throw new TypeError('Error must be instance of Error')
    }

    if (!isObject(extra)) {
      throw new TypeError('extra must be an object')
    }

    if (!isObject(tagMap) || !isObjectValuesAreString(tagMap)) {
      throw new TypeError('tagMap must be valid map')
    }
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tags
   * @param {string} level
   * @private
   */
  _log (error, extra, tags, level) {
    this._sentry.withScope(scope => {
      const context = this._getContext()

      if (context.user) {
        scope.setUser(context.user)
      }

      if (isObject(context.tags)) {
        tags = {
          ...tags,
          ...context.tags
        }
      }

      Object.entries(tags)
        .forEach(([tagKey, tagValue]) => scope.setTag(tagKey, tagValue))

      scope.setLevel(level)
      scope.setExtra('extra', ignoreThirdLevelOfNestingObject(extra))

      this._sentry.captureException(error)
    })
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  error (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    this._log(error, extra, tagMap, ILogger.ERROR)
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  warning (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    this._log(error, extra, tagMap, ILogger.WARNING)
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  info (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    this._log(error, extra, tagMap, ILogger.INFO)
  }

  /**
   * @param {Error} error
   * @param {object} extra
   * @param {object} tagMap
   */
  debug (error, extra = {}, tagMap = {}) {
    this._validate(error, extra, tagMap)

    this._log(error, extra, tagMap, ILogger.DEBUG)
  }
}



// WEBPACK FOOTER //
// ./src/utils/Logger/SentryLogger.js